<template>
  <v-dialog v-model="dialog" persistent max-width="1000px" content-class="report-error-dialog" :fullscreen="$vuetify.breakpoint.smAndDown">
    <template v-if="dialog">
      <v-flex style="overflow: auto;">
        <v-card style="position: relative;" tile flat>
          <v-chip v-if="processInstanceId" small class="caption mt-1 mr-1" style="position: absolute; right: 4px; top: 4px;">{{ processInstanceId }}</v-chip>
          <v-card-text>
            <div v-if="!loading" class="mb-4 mt-2">
              <div class="headline mb-3 break-all">
                <slot name="title" v-bind="executionResults" :isError="isError">
                  <v-icon v-if="isError" class="mr-1" color="error" large>error</v-icon>
                  <v-icon v-else large class="mr-1" color="success">check_circle</v-icon>

                  <span v-if="displayMessage" v-html="displayMessage" />
                  <span v-else v-html="`${title} ${isError ? 'failed' : 'successful'}`" />
                </slot>
              </div>

              <div v-if="hasLogs"> See the logs below for details. </div>
              <div v-if="unexpectedErrorMessage">
                An unexpected error occurred.
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card v-if="hasLogs" flat tile style="max-height: 450px; overflow: auto;">
          <v-card-title class="title py-2">
            <v-icon class="mr-1">receipt_long</v-icon>
            Logs ({{ userLogs.length }})
            <SecondaryBtn flat small color="info" :icon="showLogs ? 'expand_less' : 'expand_more'" @click="showLogs = !showLogs">
              {{ showLogs ? 'Hide logs' : 'Show logs' }}
            </SecondaryBtn>
          </v-card-title>
          <v-card-text v-if="showLogs">
            <UserLogs class="pb-1 card-bg-3" :userLogs="userLogs" />
            <v-divider />
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card class="pt-3" flat tile style="max-height: 450px; overflow: auto;">
          <v-card-title class="title py-2">
            <v-icon class="mr-1">support</v-icon>
            Recommended actions
          </v-card-title>
          <v-card-text class="pt-0">
            <slot v-if="isError" name="actions" v-bind="executionResults" :isError="isError">
              There are no recommended actions. Please try again or contact Hatfield support for assistance.
            </slot>
            <slot v-else name="next" v-bind="executionResults" :isError="isError">
              There are no recommended actions.
            </slot>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex>
        <v-card>
          <v-divider />
          <v-card-actions>
            <ContactSupport v-if="isError" :userLogs="userLogs" :displayMessage="displayMessage" :processInstanceId="processInstanceId" :message="unexpectedErrorMessage" />
            <v-spacer />
            <SecondaryBtn icon="close" @click="attemptToClose()">
              Close
            </SecondaryBtn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </template>
  </v-dialog>
</template>

<script>
  import UserLogs from '@/components/ExecutionResults/UserLogs'

  const initialResults = () => ({
    DisplayMessage: '',
    UserLogs: [],
    IsError: false,
  })

  const hasFalseValue = (obj, keys) => keys.some(key => obj[key] === false)

  export default {
    components: {
      UserLogs,
    },
    props: {
      title: {
        type: String,
        default: 'Process',
      },
      shouldClose: {
        type: Boolean,
        default: true,
      },
    },
    data: () => ({
      dialog: false,
      executionResults: initialResults(),
      showLogs: false,
      loading: false,
    }),
    computed: {
      displayMessage() {
        return this.executionResults.DisplayMessage || this.executionResults.displayMessage
      },
      reasonPhrase() {
        return this.executionResults.ReasonPhrase || this.executionResults.reasonPhrase
      },
      isError() {
        let keys = ['IsError', 'isError', 'unexpectedErrorMessage']
        return !hasFalseValue(this.executionResults, keys)
      },
      userLogs() {
        return this.executionResults.UserLogs || this.executionResults.userLogs || []
      },
      hasLogs() {
        return this.userLogs && this.userLogs.length > 0
      },
      processInstanceId() {
        return this.executionResults.ProcessInstanceId || this.executionResults.processInstanceId || this.executionResults.ProcessId || this.executionResults.processId
      },
      unexpectedErrorMessage() {
        if (typeof(this.executionResults) == 'string' || this.executionResults instanceof String) return this.executionResults
      },
    },
    methods: {
      show(executionResults) {
        console.log('er', executionResults)
        if (typeof(executionResults) != 'object') {
          this.executionResults = {
            isError: true,
            displayMessage: 'An unknown error occurred, please contact Hatfield for assistance',
            userLogs: [{
              eventLevel: 3,
              message: executionResults,
            }],
          }
        } else {
          this.executionResults = executionResults
        }

        this.dialog = true
        this.loading = false
      },
      // Use this if an exception is caught, otherwise it will show as successful
      showError(executionResults) {
        this.show(executionResults)
        this.executionResults.IsError = true
        this.executionResults.DisplayMessage = executionResults.Message || 'An unknown error occurred, please contact Hatfield for assistance'
      },
      attemptToClose() {
        if (!this.isError && this.shouldClose) {          
          this.$emit('close')
        }
        this.$emit('close_waring')
        this.close()
      },
      close() {
        this.dialog = false
      },
      clearLogs() {
        this.executionResults = initialResults()
        this.loading = true
      },
    },
  }
</script>

<style scoped>
  .v-dialog--fullscreen>.v-card {
    min-height: 85px !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card {
    min-height: Calc(100% - 85px) !important;
  }

  .v-dialog--fullscreen>.v-card+.v-card .v-card__text {
    padding: 0px !important;
  }
</style>